<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-mahjongTiger">
      <div class="px-1 col-3 p-0">
        <div class="heading-mahjongTiger">{{ $t("result.round") }}</div>
        <div class="text-subhead-mahjongTiger">{{ data.roundId }}</div>
      </div>
      <div class="px-1 col-3">
        <div class="heading-mahjongTiger">
          {{ $t("result.bet") + `${currency}` }}
        </div>
        <div class="text-subhead-mahjongTiger">
          {{ this.data.count === 0
            ? this.data.bet
            : this.data.detail.summary[this.data.count].bet.amount | currencyFormatter }}
        </div>
      </div>
      <div class="px-1 col-3">
        <div class="heading-mahjongTiger">
          {{ $t("result.winlose") + `${currency}` }}
        </div>
        <div class="text-subhead-mahjongTiger">
          {{ this.winlose | currencyFormatter }}
        </div>
      </div>
      <div class="px-1 col-3">
        <div class="heading-mahjongTiger">
          {{ $t("result.balance") + `${currency}` }}
        </div>
        <div class="text-subhead-mahjongTiger">
          {{ (this.balance) | currencyFormatter }}
        </div>
      </div>
    </div>

    <div class="nav-fixed-container">
      <div class="slot-nav nav-fixed-left">
        <i v-if="canGoPrev() == true" class="fas fa-caret-left arrow-side-mahjongTiger" @click="delCount"></i>
      </div>
      <div class="slot-nav nav-fixed-right">
        <i v-if="canGoNext() == true" class="fas fa-caret-right arrow-side-mahjongTiger" @click="addCount"></i>
      </div>
    </div>

    <div class="content-bg-wrapper">
      <div class="content-result-mahjongTiger pt-3">
        <div class="text-games-mahjongTiger">{{ $t("mahjongTiger.name") }}</div>
        <div class="text-date mb-1">{{ data.timestamp }}</div>

        <div class="col-12 justify-content-center d-flex flex-row py-5">
          <div class="d-flex flex-column">

            <span v-for="(multiplierClass, multiplierIndex) in getMultiplierClasses(2)" :key="multiplierIndex"
              :class="multiplierClass"></span>

            <div ref="slotWrapper" class="multiplier-wrap">
              <img v-if="state === 'FREESPIN' || state === 'FREERESPIN'" class="multiplier_bg"
                :src="require(`../../assets/resultGame/mahjongTiger/header_free_bg_vertical.png`)" alt="" />
              <img v-if="state === 'SETUPFREESPIN'" class="multiplier_bg"
                :src="require(`../../assets/resultGame/mahjongTiger/header_normal_bg_vertical.png`)" alt="" />
              <img v-if="state === 'SPIN' || state === 'RESPIN'" class="multiplier_bg"
                :src="require(`../../assets/resultGame/mahjongTiger/header_normal_bg_vertical.png`)" alt="" />

              <div class="multiplier-text-row">
                <div v-for="(value, index) in multiplierSet" :key="index"
                  :class="`${multiplier == value ? 'bmt-text' : 'bmf-text'} mul-item ${index === 0 ? 'first' : index === multiplierSet.length - 1 ? 'last' : ''}`"
                  id="mul_0" :style="`transform: scale(${fontScale})`">
                  <span :class="`${multiplier == value ? 'bmt bmt-x' : 'bmf bmf-x'}`"></span>
                  <span v-for="num in value.toString()" :key="num"
                    :class="`${multiplier == value ? `bmt bmt-${num}` : `bmf bmf-${num}`}`"></span>
                </div>
              </div>
            </div>

            <div class="d-flex flex-row slot-container">
              <div v-for="(reel, index) in this.reels" :key="index" class="d-flex flex-column">
                <div v-for="(symbol, symbolIndex) in reel" :key="symbolIndex">
                  <img class="icon-symbol-mahjongTiger" :src="require(`../../assets/resultGame/mahjongTiger/sym_${symbol}.png`)
                    " alt="" />
                </div>
              </div>
            </div>


          </div>
        </div>

        <div class="text-center py-2 text-games-mahjongTiger">
          <h1 v-if="isFreespin">
            {{ $t("result.freespin") }} {{ roundData.freeSpin.round }}/{{ roundData.freeSpin.remain }}
          </h1>
          <h1 v-else>{{ $t("result.spin") }} {{ this.data.count + 1 }}/{{ spinList.length }}</h1>
        </div>

        <div v-if="isFreespin" class="justify-content-center align-items-center text-center d-flex flex-row">
          <h1 class="my-1 green">{{ getRound() }}</h1>
        </div>

        <div v-if="data.detail.featureBuy" class="text-subgame-mahjongTiger py-2"> Feature Buy </div>

        <div class="justify-content-center align-items-center text-center d-flex flex-row">
          <h1 class="my-1 green">{{ $t("result.multiplier") }} x {{ this.multiplier }}</h1>
        </div>

        <div v-if="!!this.winnings && this.winnings.length > 0" class="col-12 justify-content-center d-flex flex-row">
          <hr class="line col-3" />
          <div class="text-detail align-items-center d-flex px-3"> {{ $t("result.detail") }} </div>
          <hr class="line col-3" />
        </div>

        <div v-if="winnings.length > 0">
          <div v-for="(detail, index) in winnings" :key="index"
            class="bet-wrapper justify-content-between item d-flex flex-row col-12 pt-2">
            <div class="d-flex flex-row">
              <div style="margin-left:10px" class="d-flex text-win align-items-center justify-content-center">
                <img class="icon-detail-mahjongTiger"
                  :src="require(`../../assets/resultGame/mahjongTiger/sym_${detail.symbol}.png`)" alt="" />
                <div class="text-multiplier d-flex flex-column justify-content-center align-items-left">
                  <span v-if="detail.symbol !== 10 && detail.symbol !== 11" class="my-1 green"
                    style="padding-left: 10px; text-align: left;">
                    {{ `${detail.row} ` + $t('result.kind') }}
                  </span>
                  <span class="my-1 green" style="padding-left: 10px; color: darkgray; text-align: left;">
                    {{ detail.count }} {{ $t("result.way") }} = {{ (detail.amount / multiplier) | currencyFormatter }}
                    {{ multiplier > 1 ? `X${multiplier}` : '' }}
                  </span>
                </div>
              </div>
            </div>
            <div class="d-flex text-win justify-content-center align-items-center px-1">
              <p class="my-1 green" style="text-align: right;">
                {{ currency }} {{ detail.amount | currencyFormatter }}
              </p>
            </div>
          </div>
        </div>
        <div v-if="scatterCount >= 3" class="bet-wrapper justify-content-between item d-flex flex-row col-12 pt-2">
          <div class="d-flex flex-row">
            <div style="margin-left:10px" class="d-flex text-win align-items-center justify-content-center">
              <img class="icon-detail-mahjongTiger" :src="require(`../../assets/resultGame/mahjongTiger/sym_${8}.png`)"
                alt="" />
              <div class="text-multiplier d-flex flex-column justify-content-center align-items-left">
                <span class="my-1 green" style="padding-left: 10px; color: darkgray; text-align: left;">
                  X{{ scatterCount }}
                </span>
              </div>
            </div>
          </div>
          <div class="d-flex text-win justify-content-center align-items-center px-1">
            <p class="my-1 green" style="text-align: right;">
              +{{ getFreeSpin() }} Freespin
            </p>
          </div>
        </div>

        <div class="footer-space"></div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-mahjongTiger",
  props: {
    data: Object,
    page: Number,
    isback: Boolean
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t)
      ,
      balance: 0,
      bet: 0,
      count: 0,
      currency: this.data.currency ? this.data.currency : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      roundId: "",
      timestamp: "",
      winlose: 0,
      isFreespin: false,
      multiplier: 0,
      reels: [],
      reelSizes: [],
      newReel: [],
      isEndRound: false,
      round: 1,
      pagesCount: 0,
      winnings: [],
      multiplierSet: [],
      pages: 0,
      isGamble: false,
      spinList: [],
      freeSpinList: [],
      scatterCount: 0,
      freespin: null,
      roundData: null,

      fontScale: 1,
      bmtBaseWidth: 800,
      bmtBaseHeight: 800,
      bmtMinScale: 0.4,
      bmtMaxScale: 1.2,
    };
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }

    this.sortData();
  },
  mounted() {
    this.headerHeight = document.getElementsByClassName(
      "header-mahjongTiger"
    )[0].offsetHeight;
    window.addEventListener("resize", this.updateFontScale);
    this.updateFontScale();
  },
  methods: {
    updateFontScale: function () {
      let self = this;
      this.$nextTick(() => {
        const scaleX = window.innerWidth / this.bmtBaseWidth;
        const scaleY = window.innerHeight / this.bmtBaseHeight;
        const rawScale = Math.min(scaleX, scaleY);
        self.fontScale = self.clamp(rawScale, self.bmtMinScale, self.bmtMaxScale);
      });
    },
    clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    },
    async mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.isEndRound = result.isEndRound;
      this.state = result.state;
      this.mode = result.freeSpin ? result.freeSpin.mode : 0;
      this.reels = result.reels;
      this.winnings = result.winnings;
      if (result.multiplierSet) this.multiplierSet = result.multiplierSet;
      else this.multiplierSet = [1, 2, 4, 7];

      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      if (this.state === 'SPIN' || this.state === 'RESPIN')
        this.multiplier = result.multiplier;
      else
        this.multiplier = result.multiplier;

      if (result.isCoin) this.currency = 'AMS';

      this.scatterCount = result.reels.flat().filter(n => n === 8).length;
      this.freespin = result.freeSpin;
      this.roundData = result;
      this.isFreespin = this.state === 'FREESPIN' || this.state === 'FREERESPIN';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }

    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    canGoPrev() {
      return this.state != 'SPIN';
    },
    canGoNext() {
      return !this.isEndRound;
    },
    getMultiplierClasses(multiplier) {
      if (multiplier == null || multiplier <= 1) {
        return [];
      }
      var value = String(multiplier);
      var classes = ["cx"];
      for (var i = 0; i < value.length; i++) {
        var char = value.charAt(i);

        if (char >= "0" && char <= "9") {
          classes.push("c" + char);
        }
      }
      return classes;
    },
    sortData() {
      let spin = [];
      let freespin = [];
      this.data.detail.summary.forEach(data => {
        if (data.state === 'SPIN' || data.state === 'RESPIN') {
          spin.push(data)
        } else {
          if (freespin[data.freeSpin.round - 1]) freespin[data.freeSpin.round - 1].push(data)
          else freespin[data.freeSpin.round - 1] = [data];
        }
      })
      this.spinList = spin;
      this.freeSpinList = freespin;
    },
    getFreeSpin() {
      if (this.state === 'FREESPIN' || this.state === 'FREERESPIN') {
        return this.freespin.retrigger;
      } else {
        let result = this.data.detail.summary[this.page + 1];
        return result.freeSpin.remain;
      }
    },
    getRound() {
      let index = this.freeSpinList.findIndex(subArr => subArr.includes(this.roundData));
      if (this.freeSpinList[index].length > 1) return `${this.$t("result.spinRound")}: ${this.roundData.spinRound}/${this.freeSpinList[index].length}`;
      else return '';
    }
  },
};
</script>
<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933;
  margin: 0;
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.text-win {
  height: 144px;
}

.fg-image {
  width: 570px;
}

.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-mahjongTiger {
  width: clamp(10%, 100%, 30%);
  height: auto;
}

.icon-bonus-mahjongTiger {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-mahjongTiger {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-mahjongTiger {
  /* background: #0c161f; */
  border-radius: 10px;
  min-height: 200px;
  max-height: 500px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.bonus-box-mahjongTiger {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-mahjongTiger .item {
  color: #fff;
  /* background: #06112d; */
  line-height: 1;
  border-radius: 10px;
  /* border: 1.5px solid #cac095; */
}

.bet-box-mahjongTiger .bet-wrapper-mahjongTiger:not(:first-child) .item {
  margin-top: 10px;
  /* width: 800px; */
}

.bet-wrapper-mahjongTiger,
.result-wrapper {
  font-size: 35px;
  /* width: 800px; */
}

.header-mahjongTiger {
  background: #05D1BF;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-mahjongTiger>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-mahjongTiger {
  color: #000000;
  text-align: center;
}

.content-result-mahjongTiger {
  width: 80%;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: scroll;
}

.title>.heading-mahjongTiger {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-mahjongTiger {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-mahjongTiger {
  font-size: 20px;
  color: #fff;
  text-align: center;
  white-space: normal;
  word-break: break-all;
}

.text-subgame-mahjongTiger {
  font-size: 20px;
  color: #ffd500;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.icon-symbol-mahjongTiger {
  width: 100%;
  /* padding: 5%; */
}

.bet-box-mahjongTiger {
  min-width: 600px;
  max-width: auto;
}

.win-box {
  width: 760px;
}

.icon-symbol {
  position: absolute;
  transform: translate(-108px, 0px);
}

.icon-symbol.-level1 {
  width: 109px;
  height: 89px;
}

.icon-symbol.-level2 {
  width: 109px;
  height: 176px;
}

.icon-symbol.-level3 {
  width: 109px;
  height: 266px;
}

.icon-symbol.-level4 {
  width: 112px;
  height: 352px;
}

.slot-container {
  position: relative;
  align-items: center;
  align-self: center;
}

.multiplier-container {
  width: 100%;
}

.top-reel {
  display: flex;
  flex-direction: row;
  position: relative;
}

.table-pos {
  transform: translate(0px, -7px);
}

.text-multiplier {
  width: 100%;
  text-align: center;
}

@media screen and (max-width: 1030px) {

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-mahjongTiger {
    min-width: 580px;
    max-width: auto;
    height: 100%;
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px;
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-126px, 0px);
  }

  .icon-symbol.-level1 {
    width: 127px;
    height: 104px;
  }

  .icon-symbol.-level2 {
    width: 126px;
    height: 209px;
  }

  .icon-symbol.-level3 {
    width: 127px;
    height: 314px;
  }

  .icon-symbol.-level4 {
    width: 127px;
    height: 419px;
  }
}

@media screen and (min-width: 1060px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -115px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-mahjongTiger,
  .result-wrapper {
    font-size: 33px;
    /* width: 800px; */
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-127px, 0px);
  }

  .icon-symbol.-level1 {
    width: 127px;
    height: 105px;
  }

  .icon-symbol.-level2 {
    width: 126px;
    height: 210px;
  }

  .icon-symbol.-level3 {
    width: 127px;
    height: 315px;
  }

  .icon-symbol.-level4 {
    width: 126px;
    height: 419px;
  }
}

.line {
  background-color: #fff;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #fff;
  font-size: 35px;
}

.win-box {
  width: 689px;
}

@media screen and (max-width: 770px) {
  .heading-mahjongTiger {
    font-size: 18px;
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-mahjongTiger {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-mahjongTiger {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 67%;
    transform: translate(104px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-107px, 0px);
  }

  .icon-symbol.-level1 {
    width: 107px;
    height: 89px;
  }

  .icon-symbol.-level2 {
    width: 107px;
    height: 177px;
  }

  .icon-symbol.-level3 {
    width: 107px;
    height: 264px;
  }

  .icon-symbol.-level4 {
    width: 106px;
    height: 352px;
  }

  .multiplier-container {
    width: 80%;
  }

  .green {
    font-size: 40px;
  }
}

@media screen and (max-width: 800px) {
  .top-reel {
    width: 67%;
    transform: translate(111px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-111px, 0px);
  }

  .icon-symbol.-level1 {
    width: 110px;
    height: 92px;
  }

  .icon-symbol.-level2 {
    width: 111px;
    height: 183px;
  }

  .icon-symbol.-level3 {
    width: 111px;
    height: 275px;
  }

  .icon-symbol.-level4 {
    width: 111px;
    height: 367px;
  }
}

@media screen and (max-width: 780px) {
  .top-reel {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 67%;
    transform: translate(105px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-107px, 0px);
  }

  .icon-symbol.-level1 {
    width: 107px;
    height: 89px;
  }

  .icon-symbol.-level2 {
    width: 107px;
    height: 177px;
  }

  .icon-symbol.-level3 {
    width: 107px;
    height: 264px;
  }

  .icon-symbol.-level4 {
    width: 106px;
    height: 352px;
  }
}

@media screen and (max-width: 600px) {
  .top-reel {
    width: 67%;
    transform: translate(82px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-83px, 0px);
  }

  .icon-symbol.-level1 {
    width: 83px;
    height: 70px;
  }

  .icon-symbol.-level2 {
    width: 83px;
    height: 138px;
  }

  .icon-symbol.-level3 {
    width: 83px;
    height: 207px;
  }

  .icon-symbol.-level4 {
    width: 83px;
    height: 275px;
  }
}

@media screen and (max-width: 480px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-mahjongTiger>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-mahjongTiger {
    font-size: 12px;
  }

  .text-subhead-mahjongTiger {
    font-size: 12px;
  }

  .bet-box-mahjongTiger {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bonus-box-mahjongTiger {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-mahjongTiger,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-bonus-mahjongTiger {
    width: 60px;
    height: 60px;
  }

  .top-reel {
    width: 67%;
    transform: translate(62px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-63px, 0px);
  }

  .icon-symbol.-level1 {
    width: 63px;
    height: 52px;
  }

  .icon-symbol.-level2 {
    width: 63px;
    height: 104px;
  }

  .icon-symbol.-level3 {
    width: 63px;
    height: 155px;
  }

  .icon-symbol.-level4 {
    width: 63px;
    height: 207px;
  }

  .green {
    font-size: 18px;
  }

  .text-win {
    height: 80px;
  }
}

@media screen and (max-width: 550px) {
  .fg-image {
    width: 390px;
  }

  .wheel-wrapper {
    width: 396px;
  }

  .container {
    padding-bottom: 67px;
  }

  .win-box {
    width: 760px;
  }

  .green {
    font-size: 19px;
  }
}

/* =========================
   Fixed Navigation
========================= */
.nav-fixed-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 999;
}

.nav-fixed-left,
.nav-fixed-right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: all;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-fixed-left {
  left: 10px;
}

.nav-fixed-right {
  right: 10px;
}

/* =========================
   Navigation
========================= */
.slot-nav {
  color: #fff;
}

.arrow-side-mahjongTiger {
  cursor: pointer;
  color: #fff;
  text-align: center;
  font-size: 70px;
}

.content-bg-wrapper {
  width: 100%;
  min-height: 100vh;
  background: #0C1E30;
}

.footer-space {
  height: 100px;
}

.multiplier_bg {
  width: 100%;
}

.bmf {
  display: inline-block;
  background-image: url("../../assets/resultGame/mahjongTiger/shadow.png");
  background-repeat: no-repeat;
  background-size: 843px 88px;
  vertical-align: top;
}

.bmf-0 {
  width: 39px;
  height: 48px;
  background-position: -100px -20px;
}

.bmf-1 {
  width: 26px;
  height: 48px;
  background-position: -729px -20px;
}

.bmf-2 {
  width: 38px;
  height: 48px;
  background-position: -495px -20px;
}

.bmf-3 {
  width: 39px;
  height: 48px;
  background-position: -179px -20px;
}

.bmf-4 {
  width: 38px;
  height: 48px;
  background-position: -573px -20px;
}

.bmf-5 {
  width: 39px;
  height: 48px;
  background-position: -258px -20px;
}

.bmf-6 {
  width: 40px;
  height: 48px;
  background-position: -20px -20px;
}

.bmf-7 {
  width: 38px;
  height: 48px;
  background-position: -651px -20px;
}

.bmf-8 {
  width: 39px;
  height: 48px;
  background-position: -337px -20px;
}

.bmf-9 {
  width: 39px;
  height: 48px;
  background-position: -416px -20px;
}

.bmf-x {
  width: 28px;
  height: 35px;
  background-position: -795px -20px;
  margin-top: 10px;
}

.bmf-text {
  display: inline-flex;
  align-items: flex-start;
  --char-spacing: -40px;
}

.bmt {
  display: inline-block;
  background-image: url("../../assets/resultGame/mahjongTiger/multiplier.png");
  background-repeat: no-repeat;
  background-size: 1024px 1024px;
  vertical-align: top;
  flex: 0 0 auto;
  scale: 0.4;
}

.bmt-text {
  display: inline-flex;
  align-items: flex-start;
  --char-spacing: -100px;
}

.bmt-text .bmt {
  margin: 0 !important;
}

.bmt-text .bmt+.bmt {
  margin-left: var(--char-spacing) !important;
}

/* digits */
.bmt-0 {
  width: 134px;
  height: 198px;
  background-position: -610px -50px;
  margin-right: 9px;
}

.bmt-1 {
  width: 134px;
  height: 198px;
  background-position: -250px -550px;
  margin-right: 9px;
}

.bmt-2 {
  width: 134px;
  height: 198px;
  background-position: -250px -300px;
  margin-right: 9px;
}

.bmt-3 {
  width: 134px;
  height: 198px;
  background-position: -800px -50px;
  margin-right: 9px;
}

.bmt-4 {
  width: 134px;
  height: 198px;
  background-position: -610px -300px;
  margin-right: 9px;
}

.bmt-5 {
  width: 134px;
  height: 198px;
  background-position: -50px -300px;
  margin-right: 9px;
}

.bmt-6 {
  width: 134px;
  height: 198px;
  background-position: -250px -50px;
  margin-right: 9px;
}

.bmt-7 {
  width: 134px;
  height: 198px;
  background-position: -50px -550px;
  margin-right: 9px;
}

.bmt-8 {
  width: 134px;
  height: 198px;
  background-position: -420px -50px;
  margin-right: 9px;
}

.bmt-9 {
  width: 134px;
  height: 198px;
  background-position: -50px -50px;
  margin-right: 9px;
}

/* letters */
.bmt-x {
  width: 134px;
  height: 198px;
  background-position: -420px -300px;
  margin-right: 9px;
}

.bmt-F {
  width: 134px;
  height: 198px;
  background-position: -800px -300px;
  margin-right: 9px;
}

.bmt-M {
  width: 134px;
  height: 198px;
  background-position: -800px -541px;
  margin-right: 9px;
}

.bmt-K {
  width: 134px;
  height: 198px;
  background-position: -50px -785px;
  margin-right: 9px;
}

.bmt-W {
  width: 134px;
  height: 198px;
  background-position: -250px -768px;
  margin-right: 9px;
}

/* symbols */
.bmt-percent {
  width: 134px;
  height: 198px;
  background-position: -610px -550px;
  margin-right: 9px;
}

.bmt-comma {
  width: 54px;
  height: 91px;
  background-position: -800px -785px;
  margin-left: 10px;
  margin-top: 133px;
  margin-right: 3px;
}

.bmt-dot {
  width: 54px;
  height: 66px;
  background-position: -880px -785px;
  margin-left: 9px;
  margin-top: 132px;
  margin-right: 4px;
}

.bmt-plus {
  width: 108px;
  height: 100px;
  background-position: -610px -785px;
  margin-left: -20px;
  margin-top: 50px;
  margin-right: -21px;
}

.bmt-minus {
  width: 108px;
  height: 100px;
  background-position: -420px -785px;
  margin-left: -20px;
  margin-top: 50px;
  margin-right: -21px;
}

.multiplier-row {
  position: absolute;
  top: 17%;
  transform: translateX(-50%) scale(var(--scale));
  transform-origin: center center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 7vw;

  /* ปรับตามจอ */
  --scale: clamp(0.6, 100vw / 390, 1.4);
}

.multiplier-wrap {
  position: relative;
  width: 100%;
  display: inline-block;
}

.multiplier_bg {
  display: block;
  width: 100%;
  height: auto;
}

.multiplier-text-row {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  pointer-events: none;
  padding-left: 10%;
  padding-right: 10%;
  padding-top: 6%;
}

.mul-item {
  width: 25%;
  display: inline-flex;
  justify-content: center;
  align-items: flex-start;
  transform-origin: center center;
}

.first,
.last {
  padding-top: 3%;
}
</style>
